import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners
} from "@angular/core";
import { provideRouter, withInMemoryScrolling } from "@angular/router";
import { provideHttpClient, withInterceptors, withXhr } from "@angular/common/http";
import { en_US, provideNzI18n } from "ng-zorro-antd/i18n";
import { createErrorHandler, TraceService } from "@sentry/angular";
import { routes } from "./app.routes";
import { credentialsInterceptor } from "./libs/interceptors/credentials.interceptor";
import { authErrorInterceptor } from "./libs/interceptors/auth-error.interceptor";
import { localeInterceptor } from "./libs/interceptors/locale.interceptor";

import {
  BgColorsOutline,
  CheckCircleOutline,
  EditOutline,
  HomeOutline,
  RiseOutline,
  TeamOutline,
  UserOutline,
  DashboardOutline,
  BankOutline,
  PlusOutline,
  SettingOutline,
  ArrowLeftOutline,
  EnvironmentOutline,
  SolutionOutline,
  ApartmentOutline,
  UsergroupAddOutline,
  UserAddOutline,
  LogoutOutline,
  MessageOutline,
  BellOutline,
  SendOutline,
  ReloadOutline,
  QrcodeOutline,
  CloseCircleOutline,
  FileProtectOutline,
  FieldTimeOutline,
  SafetyCertificateOutline,
  FileTextOutline,
  DownloadOutline,
  AuditOutline,
  PlusCircleOutline,
  FilePdfOutline,
  DeleteOutline,
  ThunderboltOutline,
  ScheduleOutline,
  EyeOutline,
  EyeInvisibleOutline
} from "@ant-design/icons-angular/icons";
import { IconDefinition } from "@ant-design/icons-angular";
import { provideNzIcons } from "ng-zorro-antd/icon";
import { provideNzDateFnsAdapter } from "ng-zorro-antd/core/time";
import { NzConfig, provideNzConfig } from "ng-zorro-antd/core/config";

const icons: IconDefinition[] = [
  HomeOutline,
  UserOutline,
  EditOutline,
  BgColorsOutline,
  TeamOutline,
  CheckCircleOutline,
  RiseOutline,
  DashboardOutline,
  BankOutline,
  PlusOutline,
  SettingOutline,
  ArrowLeftOutline,
  EnvironmentOutline,
  SolutionOutline,
  ApartmentOutline,
  UsergroupAddOutline,
  UserAddOutline,
  LogoutOutline,
  MessageOutline,
  BellOutline,
  SendOutline,
  ReloadOutline,
  QrcodeOutline,
  CloseCircleOutline,
  FileProtectOutline,
  FieldTimeOutline,
  SafetyCertificateOutline,
  FileTextOutline,
  DownloadOutline,
  AuditOutline,
  PlusOutline,
  PlusCircleOutline,
  FilePdfOutline,
  DeleteOutline,
  ThunderboltOutline,
  ScheduleOutline,
  EyeOutline,
  EyeInvisibleOutline
];

const ngZorroConfig: NzConfig = {
  theme: {
    primaryColor: "#7C5CFC"
  }
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideNzDateFnsAdapter(),
    provideBrowserGlobalErrorListeners(),
    // anchorScrolling: links like /#how-it-works (public header, footer) scroll to the section.
    provideRouter(routes, withInMemoryScrolling({ anchorScrolling: "enabled" })),
    provideHttpClient(
      withXhr(),
      withInterceptors([credentialsInterceptor, localeInterceptor, authErrorInterceptor])
    ),
    provideNzConfig(ngZorroConfig),
    provideNzI18n(en_US),
    provideNzIcons(icons),
    { provide: ErrorHandler, useValue: createErrorHandler() },
    TraceService,
    provideAppInitializer(() => {
      inject(TraceService);
    })
  ]
};
